<template>
  <div>
    <el-button class="base-margin__bottom-10" type="primary" @click="openDialog">{{
        $t('backstage.addAuthCode')
      }}
    </el-button>
    <div class="table">
      <el-table :data="tableData" class="table_width">
        <el-table-column :label="$t('backstage.id')" prop="id"></el-table-column>
        <el-table-column :label="$t('backstage.authCodeName')" prop="name" width="200"></el-table-column>
        <el-table-column :label="$t('backstage.authCode')" min-width="300" prop="secretKey">
          <template slot-scope="scope">
            <div class="ellipsis_nowrap_cls">{{ scope.row.secretKey }}</div>
          </template>
        </el-table-column>

        <el-table-column :label="$t('backstage.status')">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? '' : 'success' ">{{
                scope.row.status === 1 ? $t('backstage.notActivated') : $t('backstage.activated')
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('backstage.activatedUser')" prop="user.name">
          <template slot-scope="scope">
            {{ scope.row.user.name === '' ? '-' : scope.row.user.name }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('backstage.period')" prop="period">
          <template slot-scope="scope">
            {{ scope.row.period }}{{ $t('backstage.months') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('backstage.activationTime')">
          <template slot-scope="scope">
            {{ disposeTime(scope.row.startAt) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('backstage.createTime')" prop="createTime" width="160"></el-table-column>
        <el-table-column
          :label="$t('backstage.actions')"
          width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="openEmail(scope.row.secretKey)">{{ $t('backstage.sendEmail') }}</el-button>
            <el-button type="text" @click="copyCode(scope.row.secretKey)">{{ $t('backstage.copy') }}</el-button>
            <el-button type="text" @click="deleteMarketSkey(scope.row.id)">{{ $t('backstage.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <el-pagination
        :page-size="10"
        :page-sizes="[10, 20, 50, 100]"
        :total="tableDataTotal"
        align="right"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="onCurrentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('backstage.createAuthCode')"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form ref="formLabelAlign" :model="formLabelAlign" label-width="100px">
        <el-form-item :label="$t('backstage.authCodeName')" prop="name">
          <el-input v-model="formLabelAlign.name" :placeholder="$t('backstage.enterAuthCodeName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('backstage.authSoftware')" prop="applicationId">
          <el-select v-model="formLabelAlign.applicationId" :placeholder="$t('backstage.selectAuthSoftware')"
                     size="large">
            <el-option
              v-for="item in describeAvailableApplicationsList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('backstage.authCodeDuration')" prop="period">
          <el-select v-model="formLabelAlign.period" :placeholder="$t('backstage.selectAuthCodeDuration')" size="large">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createCode">{{ $t('backstage.confirm') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('backstage.sendEmail')"
      :visible.sync="emailDialogVisible"
      class="open_email_cls"
      width="500px"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('backstage.userEmail')" name="userEmail">
          <el-select v-model="userEmail" :placeholder="$t('backstage.selectUserEmail')" filterable>
            <el-option
              v-for="item in emailOptions"
              :key="item.id"
              :label="item.name"
              :value="item.email">
            </el-option>
          </el-select>
        </el-tab-pane>
        <el-tab-pane :label="$t('backstage.customEmail')" name="fourth">
          <el-input v-model="userEmail" :placeholder="$t('backstage.customEmail')"></el-input>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sendEmail">{{ $t('backstage.confirm') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {getRequest, postRequest} from '@/common/libs/request';
import {Message} from 'element-ui';
import {copyText, debounce} from '@/common/utils/utils';
import dayjs from 'dayjs';

export default {
  name: 'backstage',
  data() {
    return {
      tableData: [], // 任务列表
      dialogVisible: false,
      emailDialogVisible: false,
      formLabelAlign: {
        period: '',
        name: '',
        applicationId: '',
      },
      options: [{
        value: '1',
        label: this.$t('backstage.oneMonth'),
      }, {
        value: '3',
        label: this.$t('backstage.threeMonths'),
      }, {
        value: '6',
        label: this.$t('backstage.sixMonths'),
      }, {
        value: '12',
        label: this.$t('backstage.oneYear'),
      }, {
        value: '24',
        label: this.$t('backstage.twoYears'),
      }],
      describeAvailableApplicationsList: [],
      pageIndex: 1, // 分页index
      pageLimit: 10, // 每一页条数
      tableDataTotal: 0, // 任务总数
      activeName: 'userEmail',
      userEmail: '',
      emailOptions: [],
      secretKey: '',
    };
  },
  created() {
    this.getList();
    this.getDescribeAvailableApplicationsList();
  },

  methods: {

    openDialog() {
      this.formLabelAlign = {
        period: '',
        name: '',
        applicationId: '',
      };
      this.dialogVisible = true;
    },

    /**
     * 获取授权码列表
     */
    getList() {
      const offset = this.pageLimit * (this.pageIndex - 1);
      getRequest(`/api/eda/common/admin/getMarketSkeyList?offset=${offset}&limit=${this.pageLimit}`).then((res) => {
        this.tableData = res.list;
        this.tableDataTotal = res.total;
      });
    },

    /**
     * 获取授权软件列表
     */
    getDescribeAvailableApplicationsList() {
      getRequest('/api/eda/common/admin/describeAvailableApplications?offset=0&limit=999').then((res) => {
        this.describeAvailableApplicationsList = res.applicationList;
      });
    },

    /**
     * 创建云市场授权码
     */
    createCode() {
      this.formLabelAlign.period = +this.formLabelAlign.period;
      debounce(() => {
        postRequest('/api/eda/common/admin/createMarketSkey', this.formLabelAlign).then(() => {
          Message.success(this.$t('backstage.createSuccess'));
          this.dialogVisible = false;
          this.getList();
        });
      }, 500);
    },

    // 复制授权码
    copyCode(e) {
      copyText(this, e);
    },

    /**
     * 发送邮件 弹窗
     * @param val
     */
    openEmail(val) {
      this.getUserList();
      this.userEmail = '';
      this.emailDialogVisible = true;
      this.secretKey = val;
    },

    /**
     * 发送邮件
     */
    sendEmail() {
      const emailPattern = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
      if (emailPattern.test(this.userEmail)) {
        postRequest('/api/eda/common/admin/sendEmail', {
          email: this.userEmail,
          content: this.secretKey,
          scene: 'marketSkey',
        }).then(() => {
          this.emailDialogVisible = false;
          Message.success(this.$t('backstage.sendSuccess'));
        });
      } else {
        Message.error(this.$t('backstage.emailError'));
      }
    },


    /**
     * 删除授权码
     */
    deleteMarketSkey(id) {
      this.$confirm(this.$t('backstage.deleteConfirm'), this.$t('backstage.deleteAuthCode'), {
        confirmButtonText: this.$t('backstage.confirm'),
      }).then(() => {
        postRequest('/api/eda/common/admin/deleteMarketSkey', {id: +id}).then(() => {
          this.getList();
          Message.success(this.$t('backstage.deleteSuccess'));
        });
      })
        .catch(() => {
          // Message.info('取消');
        });
    },

    /**
     * 获取用户列表
     */
    getUserList() {
      getRequest('/api/eda/common/admin/getUserList?offset=0&limit=999').then((res) => {
        this.emailOptions = res.list.filter(item => item.email !== '');
      });
    },

    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getList();
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },

    /**
     * 处理返回的标准时间
     * @param val 标准时间
     */
    disposeTime(val) {
      let dayTime = '';
      if (+val === 0) {
        dayTime = '-';
      } else {
        dayTime = dayjs(val * 1000).format('YYYY-MM-DD hh:mm:ss');
      }
      return dayTime;
    },
  },
};
</script>
<style lang="scss" scoped>
.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 500px;
  }
}

.ellipsis_nowrap_cls {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.spanCls {
  width: 80px;
  line-height: 40px;
}

.open_email_cls {
  ::v-deep .el-dialog__body {
    padding: 0 20px;
    height: 200px;
  }

  .el-dialog__body {
    padding: 0 20px;
    height: 300px;
  }
}
</style>
